import { render } from "./Team_legal.vue?vue&type=template&id=b39d667e&scoped=true"
import script from "./Team_legal.vue?vue&type=script&lang=js"
export * from "./Team_legal.vue?vue&type=script&lang=js"

import "./Team_legal.vue?vue&type=style&index=0&id=b39d667e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b39d667e"

export default script